<ng-container [formGroup]="formGroup">
  @if (showStartTs) {
    <div class="row form-group">
      <label for="startDateId" class="col-md-2 col-form-label">{{ 'Start Date' | messageTranslate }}</label>
      <div class="col-md">
        <div class="input-group">
          <input id="startDateId" required type="text" class="form-control" placeholder="yyyy-mm-dd" ngbDatepicker
                 [formControl]="getStartTsControl()" [minDate]="minDateStruct" [maxDate]="maxDateStruct"
                 #startDateControl="ngbDatepicker">
          <button class="btn btn-outline-secondary calendar" (click)="startDateControl.toggle()" type="button">
            <fa-icon icon="calendar"/>
          </button>
        </div>
        <app-errors [control]="getStartTsControl()"/>
      </div>
    </div>
  }

  @if (networkProviderPlanPeriodTypes) {
    <div class="row form-group">
      <label class="col-md-2 col-form-label">{{ 'Charges' | messageTranslate }}</label>
      <div class="col-md">
        <!-- TODO: KQ: improve track property -->
        @for (chargePeriod of getChargePeriodControls().controls; track chargePeriod; let j = $index; let last = $last) {
          <div class="row" [ngClass]="{'mb-3 mb-md-0': !last}">
            <div class="col-md-2">
              <label [for]="'monthsFromId' + j" class="form-label">{{ 'From' | messageTranslate }}</label>
              <div class="input-group">
                <select [id]="'monthsFromId' + j" class="form-select" required [formControl]="chargePeriod.get(CONTROL_KEY_START_MONTH)">
                  @for (m of monthList; track m.id) {
                    <option [ngValue]="m.id">{{m.name}}</option>
                  }
                </select>
              </div>
              <app-errors [control]="chargePeriod.get(CONTROL_KEY_START_MONTH)"/>
            </div>
            <div class="col-md-2">
              <label [for]="'monthsToId' + j" class="form-label">{{ 'To' | messageTranslate }}</label>
              <div class="input-group">
                <select [id]="'monthsToId' + j" class="form-select" required [formControl]="chargePeriod.get(CONTROL_KEY_END_MONTH)"
                        [appCustomMin]="chargePeriod.get(CONTROL_KEY_START_MONTH).value"
                        [customMinErrorMessageFn]="monthValidationMessageFunction">
                  @for (m of monthList; track m.id) {
                    <option [ngValue]="m.id">{{m.name}}</option>
                  }
                </select>
              </div>
              <app-errors [control]="chargePeriod.get(CONTROL_KEY_END_MONTH)"/>
            </div>
            <div class="col-md">
        <!-- TODO: KQ: improve track property -->
              @for (chargeControl of getChargeControls(chargePeriod).controls; track chargeControl; let i = $index) {
                <div class="row form-group">
                  <label [for]="'chargePeriod' + networkProviderPlanPeriodTypes[i].network_provider_plan_period_type_id + 'Id'" class="col-md-2 col-form-label">
                    {{ networkProviderPlanPeriodTypes[i].name }}
                  </label>
                  <div class="col-md">
                    <div class="input-group">
                      <span class="input-group-text">{{ retrieveCurrencySymbol('AUD') }}</span>
                      <input [id]="'chargePeriod' + networkProviderPlanPeriodTypes[i].network_provider_plan_period_type_id + 'Id'" required type="number" min="0"
                             class="form-control" [formControl]="chargeControl">
                    </div>
                    <app-errors [control]="chargeControl"/>
                  </div>
                </div>
              }
            </div>
            <div class="col-md-2">
              @if (last) {
                <a (click)="addChargePeriod()" class="ms-2" [title]="'Add Charge Period' | messageTranslate">
                  <fa-icon icon="plus" class="text-primary clickable"/></a>
              }
              @if (getChargePeriodControls().controls.length > 1) {
                <a (click)="removeChargePeriod(j)" class="ms-2" [title]="'Delete' | messageTranslate">
                  <fa-icon icon="trash" class="text-primary clickable"/></a>
              }
              @if (!last) {
                <hr class="d-md-none">
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-container>
